import React from "react";
export function ParagraphAnchor(props) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !!props.name && /*#__PURE__*/ React.createElement("div", {
        id: props.name
    }));
}
